import { render, staticRenderFns } from "./task-order.vue?vue&type=template&id=686aaab3&"
import script from "./task-order.vue?vue&type=script&lang=js&"
export * from "./task-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports